import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { Form8082Component } from './components/form8082/form8082.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { ConsolidationLedgersComponent } from './components/consolidation-ledgers/consolidation-ledgers.component';
import { WwniMappingComponent } from './components/wwni-mapping/wwni-mapping.component';
import { CreditDetailsComponent } from './components/credit-details/credit-details.component';
import { TaxAttributesComponent } from './components/tax-attributes/tax-attributes.component';
import { NumberWithCommasPipe } from './components/tax-attributes/number-with-commas.pipe';
import { TaxAttributesEntityInfoComponent } from './components/tax-attributes/fragments/tax-attributes-entity-info.component';
import { TaxAttributesMainPanelComponent } from './components/tax-attributes/fragments/tax-attributes-main-panel.component';
import { TaxAttributesEntityCreateFormComponent } from './components/tax-attributes/fragments/tax-attributes-entity-create-form.component';
import { TaxAttributesEntityUpdateFormComponent } from './components/tax-attributes/fragments/tax-attributes-entity-update-form.component';
import { TaxAttributesEntityPostingFormComponent } from './components/tax-attributes/fragments/tax-attributes-entity-posting-form.component';
import { TaxAttributesNestedNolComponent } from './components/tax-attributes/fragments/tax-attributes-nested-nol.component';
import { AssignPreparerComponent } from './components/assign-preparer/assign-preparer.component';
import { ExclusionListComponent } from './components/form851/851-exclusion-list/exclusion-list.component';
import { RelatedPartyChangeSystemAcctComponent } from './components/related-party-change-system-acct/related-party-change-system-acct.component';
import { RelatedPartyChangeSystemAcctService } from './components/related-party-change-system-acct/related-party-change-system-acct.service';
import { RelatedPartyInsertCategoryComponent } from './components/related-party-insert-category/related-party-insert-category.component';
import { UpdateEntityDetailsComponent } from './components/entity-details/entity-details.component';
import { LocalChartDeleteComponent } from './components/local-chart-delete/local-chart-delete.component';
import { ReviewAdjAutomationComponent } from './components/review-adj-automation/review-adj-automation.component';
import { SectionDetailsComponent } from './components/section-details/section-details.component';
import { GlLocalAcctDescComponent } from './components/GL_local_acct_desc/gl-local-acct-desc.component';
import { MethodSettlementComponent } from './components/method-settlement/method-settlement.component';
import { GofSettlementComponent } from './components/gof-settlement/gof-settlement.component';
import { MethodSettlementService } from './components/method-settlement/method-settlement.service';
import { Dashboard901MComponent } from './components/dashboard-901m/dashboard-901m.component';
import { Dashboard901MService } from './components/dashboard-901m/dashboard-901m.service';
import { BusinessSignOffComponent } from './components/business-sign-off/business-sign-off.component';
import { BusinessSignOffEditModalComponent } from './components/business-sign-off/business-sign-off-edit-modal/business-sign-off-edit-modal.component';
import { BusinessSignOffService } from './components/business-sign-off/business-sign-off.service';
import { ProjectReviewComponent } from './components/project-review/project-review.component';
import { ProjectReviewService } from './components/project-review/project-review.service';
import { RecommendedAutomationsComponent } from './components/recommended-automations/recommended-automations.component';
import { RecommendedAutomationsConfirmComponent } from './components/recommended-automations/recommended-automations-confirm.component';
import { Section174AdjAllocationsComponent } from './components/section174-adj-allocations/section174-adj-allocations.component';
import { AdjPriorYearDataComponent } from './components/adj-prior-year-data/adj-prior-year-data.component';
import { GoldAddressComponent } from './components/gold-address/gold-address.component';
import { SummaryDetailsLinkComponent } from './components/summary-details-link/summary-details-link.component';
import { SettlementMainComponent } from './components/settlement-main/settlement-main.component';
import { SettlementMainService } from './components/settlement-main/settlement-main.service';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';
import { GtwSearchableSelectModule } from '../shared/_directives/gtw-searchable-select/gtw-searchable-select.module';
import { ScheduleDadjComponent } from './components/schedule-d-adj/schedule-d-adj.component';
import { Section174AdjComponent } from './components/section174-adj/section174-adj.component';
import { PdfDataDeleteComponent } from './components/pdf-data-delete/pdf-data-delete.component';
import { F4255PartIComponent } from './components/f4255-part-i/f4255-part-i.component';
import { QreEntityDetailsComponent } from './components/qre-entity-details/qre-entity-details.component';
import { QreEntityTransformComponent } from './components/qre-entity-transform/qre-entity-transform.component';
import { QreVarianceYoyComponent } from './components/qre-variance-yoy/qre-variance-yoy.component';
import { QreVarianceExplainComponent } from './components/qre-variance-explain/qre-variance-explain.component';
import { QreCodeCombinationComponent } from './components/qre-code-combination/qre-code-combination.component';
import { QreEntityBusinessComponent } from './components/qre-entity-business/qre-entity-business.component';
import { IntercompanyDiagnosticsComponent } from './components/intercompany-diagnostics/intercompany-diagnostics.component';
import { EstFormComponent } from './components/est-form/est-form.component';
import { EstRolloverComponent } from './components/est-rollover/est-rollover.component';
import { EstQtrMaintenanceComponent } from './components/est-qtr-maintenance/est-qtr-maintenance.component';
import { FormReviewDashboardComponent } from './components/form-review-dashboard/form-review-dashboard.component';
import { Form4626Component } from './components/form4626/form4626.component';
import { FormScheduleDComponent } from './components/form-schedule-d/form-schedule-d.component';
import { Form8991Component } from './components/form8991/form8991.component';
import { Form4797Component } from './components/form4797/form4797.component';
import { CounterPartyComponent } from './components/counter-party/counter-party.component';
import { CounterPartyService } from './components/counter-party/counter-party.service';
import { CreditsPartIIIComponent } from './components/credits-part-iii/credits-part-iii.component';
import { CreditsPartIIIService } from './components/credits-part-iii/credits-part-iii.service';
import { CreditsPartIIIF8820Component } from './components/credits-part-iii/f8820/credits-part-iii-f8820.component';
import { CreditsPartIIIF8912Component } from './components/credits-part-iii/f8912/credits-part-iii-f8912.component';
import { CreditsPartIIIF8941Component } from './components/credits-part-iii/f8941/credits-part-iii-f8941.component';
import { CreditsPartIIIF8936WizardComponent } from './components/credits-part-iii/f8936/credits-part-iii-f8936-wizard.component';
import { CreditsPartIIIF8936SchAComponent } from './components/credits-part-iii/f8936/credits-part-iii-f8936-sch-a.component';
import { CreditsPartIIIF8936SchAService } from './components/credits-part-iii/f8936/credits-part-iii-f8936-sch-a.service';
import { CreditsDateVariousComponent } from './components/credits-part-iii/shared/credits-date-various/credits-date-various.component';
import { Form4562Component } from './components/form4562/form4562.component';
import { Form4562Service } from './components/form4562/form4562.service';
import { DividendsComponent } from './components/dividends/dividends.component';
import { DividendsService } from './components/dividends/dividends.service';
import { TrialBalanceComponent } from './components/trial-balance/trial-balance.component';
import { BookAdjustmentTabComponent } from './components/trial-balance/book-adjustment-tab/book-adjustment-tab.component';
import { RepointTabComponent } from './components/trial-balance/repoint-tab/repoint-tab.component';
import { MessagesComponent } from './components/messages/messages.component';
import { AddCommentComponent } from './components/add-comment/add-comment.component';
import { EstimateMappingComponent } from './components/estimate-mapping/estimate-mapping.component';
import { EstimatePostingComponent } from './components/estimate-posting/estimate-posting.component';
import { LimitationScreenComponent } from './components/limitation-screen/limitation-screen.component';
import { LockingComponent } from './components/locking/locking.component';
import { QarStdDescComponent } from './components/qar-std-desc/qar-std-desc.component';
import { QarStdDescEditComponent } from './components/qar-std-desc/qar-std-desc-edit/qar-std-desc-edit.component';
import { AdminModule } from '../admin/admin.module';
import { GridAuditCellsComponent } from './components/grid-audit-cells/grid-audit-cells.component';
import { Form851TaxualinfoComponent } from './components/form851/form851-taxualinfo/form851-taxualinfo.component';
import { SchPSaveComponent } from './components/sch-p-save/sch-p-save.component';
import { TbbsReclassService } from './components/tbbs-reclass/tbbs-reclass.service';
import { TbbsDiagnosticsService } from './components/tbbs-reclass/tbbs-diagnostics.service';
import { CreditFacilityService } from './components/credit-facility/credit-facility.service';
import { DeleteCreditFacilityComponent } from './components/credit-facility/delete-credit-facility.component';
import { GetConsolePdfComponent } from './components/credit-facility/get-console-pdf.component';
import { GetEntityPdfComponent } from './components/credit-facility/get-entity-pdf.component';
import { OnlyDigitsDirective } from './directives/only-digits.directive';
@NgModule({
  declarations: [Form8082Component,
    ConsolidationLedgersComponent,
    AssignPreparerComponent,
    WwniMappingComponent,
    CreditDetailsComponent,
    TaxAttributesComponent,
    TaxAttributesEntityInfoComponent,
    TaxAttributesMainPanelComponent,
    TaxAttributesEntityCreateFormComponent,
    TaxAttributesEntityUpdateFormComponent,
    TaxAttributesEntityPostingFormComponent,
    TaxAttributesNestedNolComponent,
    NumberWithCommasPipe,
    OnlyDigitsDirective,
    ExclusionListComponent,
    RelatedPartyChangeSystemAcctComponent,
    RelatedPartyInsertCategoryComponent,
    UpdateEntityDetailsComponent,
    LocalChartDeleteComponent,
    ReviewAdjAutomationComponent,
    SectionDetailsComponent,
    GlLocalAcctDescComponent,
    MethodSettlementComponent,
    GofSettlementComponent,
    Dashboard901MComponent,
    BusinessSignOffComponent,
    BusinessSignOffEditModalComponent,
    ProjectReviewComponent,
    RecommendedAutomationsComponent,
    RecommendedAutomationsConfirmComponent,
    SummaryDetailsLinkComponent,
    SettlementMainComponent,
    Section174AdjAllocationsComponent,
    AdjPriorYearDataComponent,
    GoldAddressComponent,
    ScheduleDadjComponent,
    Section174AdjComponent,
    PdfDataDeleteComponent,
    F4255PartIComponent,
    QreEntityDetailsComponent,
    QreEntityTransformComponent,
    QreVarianceYoyComponent,
    QreVarianceExplainComponent,
    QreCodeCombinationComponent,
    QreEntityBusinessComponent,
    IntercompanyDiagnosticsComponent,
    EstFormComponent,
    EstRolloverComponent,
    EstQtrMaintenanceComponent,
    FormReviewDashboardComponent,
    FormScheduleDComponent,
    Form4626Component,
    Form8991Component,
    Form4797Component,
    CounterPartyComponent,
    CreditsPartIIIComponent,
    CreditsPartIIIF8820Component,
    CreditsPartIIIF8912Component,
    CreditsPartIIIF8941Component,
    CreditsPartIIIF8936WizardComponent,
    CreditsPartIIIF8936SchAComponent,
    CreditsDateVariousComponent,
    Form4562Component,
    DividendsComponent,
    TrialBalanceComponent,
    BookAdjustmentTabComponent,
    RepointTabComponent,
    MessagesComponent,
    EstimateMappingComponent,
    EstimatePostingComponent,
    LimitationScreenComponent,
    LockingComponent,
    QarStdDescComponent,
    QarStdDescEditComponent,
    GridAuditCellsComponent,
    Form851TaxualinfoComponent,
    SchPSaveComponent,
    DeleteCreditFacilityComponent,
    GetConsolePdfComponent,
    GetEntityPdfComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // AppNgAppkitModule,
    AppNgMaterialModule,
    SharedComponentsModule,
    SharedDirectivesModule,
    AdminModule,
    GtwSearchableSelectModule,
    AddCommentComponent,
  ],
  providers: [
    CounterPartyService,
    CreditsPartIIIService,
    CreditsPartIIIF8936SchAService,
    Form4562Service,
    DividendsService,
    RelatedPartyChangeSystemAcctService,
    MethodSettlementService,
    Dashboard901MService,
    BusinessSignOffService,
    ProjectReviewService,
    SettlementMainService,
    TbbsReclassService,
    TbbsDiagnosticsService,
    CreditFacilityService,
    provideHttpClient(withInterceptorsFromDi(), withXhr()),
  ],
  exports: [
    ConsolidationLedgersComponent,
    WwniMappingComponent,
    CreditDetailsComponent,
    TaxAttributesComponent,
    AssignPreparerComponent,
    ExclusionListComponent,
    RelatedPartyChangeSystemAcctComponent,
    RelatedPartyInsertCategoryComponent,
    UpdateEntityDetailsComponent,
    LocalChartDeleteComponent,
    ReviewAdjAutomationComponent,
    SectionDetailsComponent,
    GlLocalAcctDescComponent,
    MethodSettlementComponent,
    GofSettlementComponent,
    Dashboard901MComponent,
    BusinessSignOffComponent,
    BusinessSignOffEditModalComponent,
    ProjectReviewComponent,
    RecommendedAutomationsComponent,
    RecommendedAutomationsConfirmComponent,
    SummaryDetailsLinkComponent,
    SettlementMainComponent,
    Section174AdjAllocationsComponent,
    AdjPriorYearDataComponent,
    GoldAddressComponent,
    ScheduleDadjComponent,
    Section174AdjComponent,
    PdfDataDeleteComponent,
    F4255PartIComponent,
    QreEntityDetailsComponent,
    QreEntityTransformComponent,
    QreVarianceYoyComponent,
    QreVarianceExplainComponent,
    QreCodeCombinationComponent,
    QreEntityBusinessComponent,
    IntercompanyDiagnosticsComponent,
    EstFormComponent,
    EstRolloverComponent,
    EstQtrMaintenanceComponent,
    FormReviewDashboardComponent,
    FormScheduleDComponent,
    Form4626Component,
    Form8991Component,
    Form4797Component,
    CounterPartyComponent,
    CreditsPartIIIComponent,
    Form4562Component,
    DividendsComponent,
    TrialBalanceComponent,
    BookAdjustmentTabComponent,
    RepointTabComponent,
    MessagesComponent,
    EstimateMappingComponent,
    EstimatePostingComponent,
    LimitationScreenComponent,
    LockingComponent,
    QarStdDescComponent,
    QarStdDescEditComponent,
    GridAuditCellsComponent,
    Form851TaxualinfoComponent,
    SchPSaveComponent,
    AddCommentComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DomesticModule { }
